import {
  CurrencyDisplay,
  LeftRightFlexedContainer,
  ModalSectionTitle,
} from "../../../../components";
import { SubmitButton, TextInput } from "../../../../hook-form";
import { ISettlePaymentIssueToMerchantBalanceFormViewProps } from "./RefundToMerchantBalanceForm";

export const View = ({
  isLoadingFormData,
  isFormEnabled,
  formDisabledReason,

  refundAmount,
  refundCurrency,

  errors,
  handleSubmit,
  register,
}: ISettlePaymentIssueToMerchantBalanceFormViewProps) => {
  return (
    <form
      onSubmit={handleSubmit}
      className="accept-as-partial--form bordered border-dashed b-r-5 pl-5 pr-5 pb-5"
    >
      <ModalSectionTitle
        key_id={
          <>
            Refund the payment into your {refundCurrency} balance. You can then
            refund the customer directly
          </>
        }
        value={""}
      />
      <div className="bg-gray-2 mt-5 mb-5 pl-5 pr-5 pb-5 pt-5 b-r-5">
        <span className="text-danger">
          <strong>
            NOTE: The original app fee will also be applied for [Amount
            Incomplete] and [Duplicate Payment] issues when settled to balance.
          </strong>
        </span>{" "}
        <br />
        If you do not wish for the app fees to be applied, use the{" "}
        <strong>"REFUND TO CUSTOMER"</strong> option
        <br />
        If you want to clear a payment/invoice, either{" "}
        <strong>"ACCEPT AS PARTIAL PAYMENT"</strong> or{" "}
        <strong>"REDIRECT TO INVOICE"</strong> for the same customer
      </div>

      <LeftRightFlexedContainer
        key_id="Amount To Settle"
        value={
          <CurrencyDisplay
            amount={refundAmount}
            currencyOrSymbol={refundCurrency}
          />
        }
      />

      <TextInput
        name="description"
        label="Description (**Required)"
        placeholder="e.g. It was used to internally settle other fees for the child"
        infoIconText="This will help you in the future to recall why you performed this action."
        type="text"
        register={register}
        errors={errors}
      />

      {!formDisabledReason || formDisabledReason === "" ? null : (
        <div className="text-danger mt-5">{formDisabledReason}</div>
      )}

      <div className="flex-container submit-button--container">
        <SubmitButton
          // size="md"
          className="mt-5 flex-box"
          showChildrenWithLoadingIcon
          disabled={!isFormEnabled}
          title={isFormEnabled ? "" : formDisabledReason}
        >
          Refund To {refundCurrency} Balance
        </SubmitButton>
      </div>
    </form>
  );
};
